import { useForm } from 'react-hook-form';
import { BackIcon } from '@braskai/icons';
import { useDeviceType } from '@braskai/ui-kit';
import { ControlledSelect } from '../../../../controlled/ControlledSelect';
import { ControlledTextField } from '../../../../controlled/ControlledTextField';
import { Data, FormValues, SurveyValues } from '../../types';
import { Actions, BackButton, Container, Option, SCheckIcon, SubmitButton } from './styled';

type TQuestionProps = {
  onSubmit: (input: FormValues) => void;
  onBack: () => void;
  data: Data;
  value: SurveyValues;
  isLastStep?: boolean;
  isLoading: boolean;
};

export const Question = ({ onSubmit, onBack, data, value, isLastStep, isLoading }: TQuestionProps) => {
  const isPreviousButton = data.step > 1;

  const {
    control,
    handleSubmit,
    watch,
    formState: { isValid },
  } = useForm<FormValues>({
    mode: 'onChange',
    defaultValues: {
      [data.controller]: value,
    },
  });

  const selectedOption = watch(`${data.controller}.option`);
  const isTextField = Array.isArray(selectedOption) ? selectedOption.includes('Other') : selectedOption === 'Other';
  const { isMobile } = useDeviceType();

  return (
    <Container>
      {isLastStep ? null : (
        <ControlledSelect
          controllerName={`${data.controller}.option`}
          control={control}
          label={data.label}
          multiple={data.multiple}
          isMenuInModal
        >
          {data.options.map((option) => (
            <Option key={option} value={option}>
              {option}
              {selectedOption.indexOf(option) > -1 ? <SCheckIcon width={12} /> : null}
            </Option>
          ))}
        </ControlledSelect>
      )}

      {isTextField || isLastStep ? (
        <ControlledTextField
          multiline
          minRows={2}
          label={isLastStep ? 'Share your feedback about your experience using Rask AI' : ''}
          control={control}
          placeholder="Your option"
          fieldName={`${data.controller}.text`}
        />
      ) : null}

      <Actions>
        {isPreviousButton ? (
          <BackButton onClick={onBack} disabled={isLoading}>
            {isMobile ? <BackIcon /> : 'Previous question'}
          </BackButton>
        ) : null}

        <SubmitButton onClick={handleSubmit(onSubmit)} disabled={!isValid || isLoading} isLoading={isLoading}>
          {isLastStep ? 'Submit ' : 'Next question'}
        </SubmitButton>
      </Actions>
    </Container>
  );
};
